class CustomerLogin extends HTMLElement {
  constructor() {
    super();
  }

  selectors = {
    login: {
      form: "#login",
      link: "[href='#login']"
    },
    recoverPassword: {
      form: "#recover",
      link: "[href='#recover']"
    }
  };

  connectedCallback() {
    this.loginForm = this.querySelector(this.selectors.login.form);
    this.recoverPasswordForm = this.querySelector(this.selectors.recoverPassword.form);

    if (window.location.hash === "#recover") {
      this.toggleRecoverPasswordForm();
    }

    document.addEventListener("click", (event) => {
      const target = event.target;

      const isLoginLink = target.closest(this.selectors.login.link);
      const isRecoverPasswordLink = target.closest(this.selectors.recoverPassword.link);

      if (isLoginLink || isRecoverPasswordLink) {
        event.preventDefault();
        this.toggleRecoverPasswordForm();
      }
    });
  }

  toggleRecoverPasswordForm() {
    this.recoverPasswordForm.hidden = !this.recoverPasswordForm.hidden;
    this.loginForm.hidden = !this.loginForm.hidden;
  }
}

if (!customElements.get("customer-login")) {
  customElements.define("customer-login", CustomerLogin);
}
